import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from './stores/auth';

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    component: () => import('./modules/m0-auth/pages/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/portal',
    component: () => import('./components/layout/PortalShell.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', component: () => import('./modules/m13-portal/pages/Home.vue') },
      { path: 'contributions', component: () => import('./modules/m13-portal/pages/Contributions.vue') },
      { path: 'pledge', component: () => import('./modules/m13-portal/pages/Pledge.vue') },
      { path: 'announcements', component: () => import('./modules/m13-portal/pages/Announcements.vue') },
      { path: 'profile', component: () => import('./modules/m13-portal/pages/Profile.vue') },
    ],
  },
  {
    path: '/staff',
    component: () => import('./components/layout/StaffShell.vue'),
    meta: { requiresAuth: true, requiresStaff: true },
    children: [
      { path: '', component: () => import('./modules/staff/pages/Dashboard.vue') },
      { path: 'members', component: () => import('./modules/m1-members/pages/List.vue') },
      { path: 'members/new', component: () => import('./modules/m1-members/pages/Create.vue') },
      { path: 'members/:id', component: () => import('./modules/m1-members/pages/Detail.vue') },
      { path: 'pledges', component: () => import('./modules/staff/pages/PledgesList.vue') },
      { path: 'offerings', component: () => import('./modules/staff/pages/OfferingsList.vue') },
      { path: 'expenses', component: () => import('./modules/staff/pages/ExpensesList.vue') },
      { path: 'reports', component: () => import('./modules/staff/pages/Reports.vue') },
      { path: 'announcements', component: () => import('./modules/staff/pages/AnnouncementsList.vue') },
      { path: 'announcements/new', component: () => import('./modules/staff/pages/AnnouncementCreate.vue') },
      { path: 'events', component: () => import('./modules/staff/pages/EventsList.vue') },
      { path: 'attendance', component: () => import('./modules/staff/pages/AttendanceList.vue') },
      { path: 'sacraments', component: () => import('./modules/staff/pages/SacramentsList.vue') },
      { path: 'assets', component: () => import('./modules/staff/pages/AssetsList.vue') },
      { path: 'groups', component: () => import('./modules/staff/pages/GroupsList.vue') },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { path: '/login' };
  }
  if (to.path === '/login' && auth.isAuthenticated) {
    const isStaff = (auth.user?.roles ?? []).some((r) => r !== 'member');
    return { path: isStaff ? '/staff' : '/portal' };
  }
});

export default router;
